module.exports = __webpack_public_path__ + "assets/img/Travel_009.eceba5bb-ps.jpg";